// jQueryのセレクタ用エスケープ処理
// http://qiita.com/mk_summer/items/6eb745c7babf2abfc03c
function selectorEscape(val) {
  return val.replace(/[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
}

export default selectorEscape;
